module.exports = __webpack_public_path__ + "static/media/DSC01491.5f884eb4.jpg";